import React from "react";
import { CheckCircle2, Clock3, XCircle, PauseCircle, Ban, Gavel, Trash2 } from "lucide-react";

const STATUS_CONFIG = {
  APPROVED: {
    label: "Approved",
    icon: CheckCircle2,
    className: "border-[#b9e4cc] bg-[#eefaf4] text-[#167a59] dark:border-[#285444] dark:bg-[#142d25] dark:text-[#67c9a1]",
  },
  PENDING: {
    label: "Pending",
    icon: Clock3,
    className: "border-[#efd5b0] bg-[#fff8eb] text-[#986022] dark:border-[#5b472d] dark:bg-[#302719] dark:text-[#e2ad6c]",
  },
  REJECTED: {
    label: "Rejected",
    icon: XCircle,
    className: "border-[#efcecc] bg-[#fff3f2] text-[#a24f4c] dark:border-[#633c3b] dark:bg-[#2b1f1e] dark:text-[#e39491]",
  },
  PAUSED: {
    label: "Paused",
    icon: PauseCircle,
    className: "border-[#efd5b0] bg-[#fff8eb] text-[#986022] dark:border-[#5b472d] dark:bg-[#302719] dark:text-[#e2ad6c]",
  },
  DISABLED: {
    label: "Disabled",
    icon: Ban,
    className: "border-[#d8e1e5] bg-[#f4f7f8] text-[#6c7f89] dark:border-[#384e5a] dark:bg-[#192a33] dark:text-[#8ca3af]",
  },
  IN_APPEAL: {
    label: "In appeal",
    icon: Gavel,
    className: "border-[#b9dff0] bg-[#edf8fd] text-[#147db5] dark:border-[#28516a] dark:bg-[#142a36] dark:text-[#6fc5eb]",
  },
  PENDING_DELETION: {
    label: "Pending deletion",
    icon: Trash2,
    className: "border-[#d8e1e5] bg-[#f4f7f8] text-[#6c7f89] dark:border-[#384e5a] dark:bg-[#192a33] dark:text-[#8ca3af]",
  },
};

const TemplateStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || {
    label: status || "Unknown",
    icon: Clock3,
    className: "border-[#d8e1e5] bg-[#f4f7f8] text-[#6c7f89] dark:border-[#384e5a] dark:bg-[#192a33] dark:text-[#8ca3af]",
  };

  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[8px] font-bold ${config.className}`}>
      <Icon size={10} strokeWidth={2} />
      {config.label}
    </span>
  );
};

export default TemplateStatusBadge;
